import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Button } from "react-bootstrap";

class ChildWelfareHistoriesList extends Component {
  render() {
    const { action, organization_name } = this.props;
    const childWelfareHistories = this.props.childWelfareHistories.filter((o) => !o._destroy);

    return (
      <Table size="sm" responsive>
        <thead>
          <tr>
            <th>Case Status</th>
            <th>Describe case in terms of duration, number of children, and ages of children</th>
            <th>Case #, ODHS Branch Name, Caseworker Name, Phone Number, and Case Dates</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {childWelfareHistories.map((o) => {
            return (
              <tr key={o.id}>
                <td>{o.title}</td>
                <td>{o.description}</td>
                <td>{o.case_details}</td>
                <td>{o.start_date}</td>
                <td>{o.end_date}</td>
                <td>
                  {action === "edit" && (
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        this.props.editChildWelfareHistory(o);
                      }}
                    >
                      Edit
                    </a>
                  )}
                </td>
              </tr>
            );
          })}
          {action == "edit" && (
            <tr>
              <td colSpan={7} className="text-center">
                <Button
                  variant="link"
                  onClick={() => {
                    this.props.newChildWelfareHistory();
                  }}
                >
                  Add Child Welfare History
                </Button>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    );
  }
}

const mapStateToProps = (state, _) => {
  return {
    isStaffApp: state.config.isStaffApp,
    childWelfareHistories: state.child_welfare_histories,
    action: state.ui.action,
    organization_name: state.organization.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    newChildWelfareHistory: () => {
      dispatch({
        type: "NEW_RESOURCE",
        payload: { resourceName: "childWelfareHistory" },
      });
    },
    editChildWelfareHistory: (resource) => {
      dispatch({
        type: "EDIT_RESOURCE",
        payload: { resourceName: "childWelfareHistory", resource },
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ChildWelfareHistoriesList);
